import MyBsSelect from "src/components/common/FormElements/MyBsSelect";
import generateOptions from "src/utils/generateOptions";
import { useRegularClassScheduleQuery } from "src/services/react-query-apis/get-regular-class-schedules";

const DayRow = ({ pos, disabled, formData, handleWeekdayChange }) => {
  const key = `day_week_${pos}`;

  const regularClassScheduleQuery = useRegularClassScheduleQuery({
    id: formData.regular_class_id,
    day_week: null,
    rank: formData.class,
    withInvalidated: 1,
    month: null,
    queryConfig: {
      enabled: !!formData.regular_class_id,
    },
  });

  const options = [{ value: "no-value", label: "曜日を選択してください" }];

  regularClassScheduleQuery?.data?.data.forEach(schedule => {
    if (!options.some(option => option.value === schedule.day_week)) {
      options.push({
        value: schedule.day_week,
        label: schedule.day_week,
      });
    }
  });

  const orderedOptions = options.sort((a, b) => {
    const dayOrder = {
      月: 1,
      火: 2,
      水: 3,
      木: 4,
      金: 5,
      土: 6,
      日: 7,
    };

    return dayOrder[a.label] - dayOrder[b.label];
  });

  return (
    <MyBsSelect
      label=""
      key={key}
      name={key}
      value={formData[key] || "no-value"}
      onChange={handleWeekdayChange}
      placeholder=""
      disabled={disabled}
      readOnly={false}
    >
      {generateOptions(orderedOptions)}
    </MyBsSelect>
  );
};

export default DayRow;
